<template>
  <span>{{ text }}</span>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

export default Vue.extend({
  name: 'UploadStatus',
  data() {
    return {
      timer: null,
      timePassing: '',
      statusConstants: {
        // 正在解析
        INTELLIGENT_UPLOAD_STATUS: 0,

        // 解析失败
        INTELLIGENT_UPLOAD_FAULT_STATUS: 1,

        // 已完成
        INTELLIGENT_COMPLETE_STATUS: 2,

        // 已生成订单
        INTELLIGENT_COMPLETE_ORDER_STATUS: 3,

        // 垃圾箱
        INTELLIGENT_RECYCLE_STATUS: 4
      }
    }
  },
  computed: {
    text() {
      const { timePassing, statusConstants, params: { value }} = this
      let str = ''
      switch (value) {
        case statusConstants.INTELLIGENT_UPLOAD_FAULT_STATUS:
          str = this.$t('SeaExport.ParsingFailed')
          break
        case statusConstants.INTELLIGENT_COMPLETE_STATUS:
          str = this.$t('SeaExport.ParsingComplete')
          break
        case statusConstants.INTELLIGENT_COMPLETE_ORDER_STATUS:
          str = this.$t('SeaExport.OrderGenerated')
          break
        case statusConstants.INTELLIGENT_RECYCLE_STATUS:
          str = this.$t('Partners.deleted')
          break
        default:
          str = this.$t('SeaExport.UploadCompletedParsing') + timePassing
          break
      }
      return str
    }
  },
  created() {
    const { statusConstants, params: { value }} = this
    if (value === statusConstants.INTELLIGENT_UPLOAD_STATUS) {
      this.setTimePassing()
      this.timer = setInterval(() => {
        this.setTimePassing()
      }, 1000)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    getTime(val) {
      let newVal = String(parseInt(val, 10))
      if (newVal.length < 2) {
        newVal = '0' + newVal
      }
      return newVal
    },
    setTimePassing() {
      const { data: { dateCreated }} = this.params
      const timePassing = moment().diff(moment(dateCreated))
      if (timePassing < 0) {
        return
      }
      const tatalSeconds = this.getTime(timePassing / 1000)
      const hours = parseInt(tatalSeconds / 3600, 10)
      const minutes = this.getTime((tatalSeconds % 3600) / 60)
      const seconds = this.getTime((tatalSeconds % 3600) % 60)
      this.timePassing = `${hours ? hours + this.$t('Pricing.Hour') : ''}${minutes ? minutes + this.$t('CargoMsg.Cargo_Cent') : ''}${seconds ? seconds + this.$t('SeaExport.Second') : ''}`
    }
  }
})
</script>

<style scoped>

</style>
